import { type z } from "@/helpers/forms/zod";
import { tolgee } from "@/providers/TranslationProvider";

export const zodErrors = (
  iss: z.core.$ZodRawIssue
): { message: string } | string | undefined | null => {
  const { code, format } = iss;

  if (code === "invalid_format" && format === "email") {
    return tolgee.t("inputs.email.error");
  }

  return undefined;
};
